"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentMenu = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("utils/components");
const models_hook_1 = require("app/models.hook");
const routes = __importStar(require("../../../../pages/modules"));
const auth_1 = require("common/auth");
const index_1 = require("../../../index");
const SegmentMenu = ({ projectId, segmentId, }) => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    (0, auth_1.useProjectPageAuthorization)(projectId);
    const { data: projectData, loading } = (0, models_hook_1.useProjectDoc)({ projectId });
    const { data: segmentData, loading: segmentLoading } = (0, models_hook_1.useSegmentDoc)({
        projectId,
        segmentId,
    });
    const { logoUrl, projectName } = projectData;
    console.log("logoUrl", logoUrl);
    if (!projectId)
        return react_1.default.createElement("div", null, "Internal error");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "menu is-menu-main" },
            react_1.default.createElement("ul", { className: "menu-list" },
                react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("LIST_SEGMENTS", { projectId }) },
                    react_1.default.createElement(components_1.Button, { width: "full", size: "lg", variant: "light" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-arrow-right-top", style: { transform: "rotate(-0.25turn)" } })),
                        react_1.default.createElement("span", { className: "menu-item-label" }, "\u30D5\u30A1\u30A4\u30EB\u4E00\u89A7\u306B\u623B\u308B"))),
                react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("LIST_SEGMENT_SCRIPTS", {
                        segmentId,
                        projectId,
                    }), className: routes.UPDATE_SEGMENT_SCRIPT.match(pathname)
                        ? "navbar-item is-edit"
                        : undefined },
                    react_1.default.createElement(components_1.Button, { width: "full", size: "lg", variant: "light" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-store" })),
                        react_1.default.createElement("span", { className: "menu-item-label" }, "\u30C6\u30AD\u30B9\u30C8\u4E00\u89A7"))),
                react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("ADD_NEW_SEGMENT", { projectId }) },
                    react_1.default.createElement(components_1.Button, { width: "full", size: "lg", variant: "light" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-pencil" })),
                        react_1.default.createElement("span", { className: "menu-item-label" }, "\u30D5\u30A1\u30A4\u30EB\u60C5\u5831")))))));
};
exports.SegmentMenu = SegmentMenu;
